import React, { memo, useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react'
import { useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import { message, Button } from 'antd'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { EmptyText } from '../../components/common/CellText'
import FileItem from '../../components/FileItemComponent/FileItem'
import { getExtensionFile } from '../../utils/common'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import { DOCUMENT_TYPE } from '../../constants'
import AuthoritiesActionModal from '../InternalDocumentOutgoing/AuthoritiesActionModal'
import * as yup from 'yup'

const InternalConnectedDocumentOutgoingCreate = props => {
  const {
    open,
    handleClose,
    bookStore,
    loadingAnimationStore,
    authenticationStore,
    companyStore,
    internalConnectedDocumentStore,
    selectedInternalDocumentOutgoing,
  } = props
  const { currentUser } = authenticationStore
  const { bookGroupList, bookListOfGroup } = bookStore
  const { createInternalConnectedDocumentOutgoing } =
    internalConnectedDocumentStore
  const [selectedCompanies, setSelectedCompanies] = useState([])
  const navigate = useNavigate()
  const formik = useFormik({
    initialValues: {
      company_code_recipients: [],
      date_issue: null,
      document_number: undefined,
      document_type: '021',
      attachments_id: [],
      sign_date: null,
      signer: selectedInternalDocumentOutgoing.signer,
      title: selectedInternalDocumentOutgoing.title,
      urgency_level: undefined,
    },
    validationSchema: yup.object().shape({
      document_number: yup
        .string()
        .required('Vui lòng nhập số hiệu!')
        .matches(/^(?=.*\S).+$/, 'Vui lòng nhập số hiệu!'),
      document_type: yup.string().required('Vui lòng chọn loại văn bản!'),
      title: yup
        .string()
        .required('Vui lòng nhập trích yếu!')
        .matches(/^(?=.*\S).+$/, 'Vui lòng nhập trích yếu!'),
      attachments_id: yup.array().min(1, 'Vui lòng chọn tài liệu đính kèm!'),
    }),
    onSubmit: async values => {
      setButtonBlock(true)
      try {
        loadingAnimationStore.showSpinner(true)
        await createInternalConnectedDocumentOutgoing(values)
        loadingAnimationStore.showSpinner(false)
        navigate('/internal-connected-document/outgoing-document')
        message.success('Tạo văn bản thành công!')
      } catch (err) {
        console.log(err)
      } finally {
        handleCloseForm()
      }
    },
  })

  useEffect(() => {
    if (!open) {
      formik.setFieldValue('signer', selectedInternalDocumentOutgoing?.signer)
      formik.setFieldValue('title', selectedInternalDocumentOutgoing?.title)
      formik.setFieldValue(
        'attachments_id',
        selectedInternalDocumentOutgoing?.attachments?.map(item => item.id)
      )
    }
  }, [open])
  useEffect(() => {
    formik.setFieldValue('signer', selectedInternalDocumentOutgoing?.signer)
    formik.setFieldValue('title', selectedInternalDocumentOutgoing?.title)
    formik.setFieldValue(
      'attachments_id',
      selectedInternalDocumentOutgoing?.attachments?.map(item => item.id)
    )
  }, [selectedInternalDocumentOutgoing])

  const [companyList, setCompanyList] = useState([])

  const getCompanyList = async () => {
    try {
      const response = await companyStore.getCompanyListV2()
      setCompanyList(response.data)
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  useEffect(() => {
    loadingAnimationStore.showSpinner(true)
    ;(async () => {
      try {
        await getCompanyList()
      } catch (err) {
        navigate('/internal-document/outgoing-document')
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    })()
  }, [])

  const [advanceFilterSignD, setAdvanceFilterSignD] = useState({
    date_by: null,
    month: '',
    tag: [],
  })

  const [advanceFilterDI, setAdvanceFilterDI] = useState({
    date_by: null,
    month: '',
    tag: [],
  })

  const handleChangeSignDate = value => {
    setAdvanceFilterSignD({
      ...advanceFilterSignD,
      month: value,
    })
    formik.setFieldValue('sign_date', value)
  }

  const handleChangeDateIssued = value => {
    setAdvanceFilterDI({
      ...advanceFilterDI,
      month: value,
    })
    formik.setFieldValue('date_issue', value)
  }

  const [selectedOption, setSelectedOption] = useState('')
  const handleSelectChange = e => {
    setSelectedOption(e.target.value)
  }
  const handleClear = () => {
    setSelectedOption('')
  }
  const [isVisibleAuthoritiesActionModal, setIsVisbleAuthoritiesActionModal] =
    useState(false)

  const handleToggleAuthoritiesActionModal = bool => event => {
    setIsVisbleAuthoritiesActionModal(bool)
  }
  // Set giá trị mặc định là phần tử đầu tiên cho loại văn bản
  useEffect(() => {
    formik.setFieldValue('document_type', '021')
  }, [])
  useEffect(() => {
    if (selectedOption === '' || selectedOption === undefined)
      setSelectedOption(undefined)
    formik.setFieldValue('urgency_level', selectedOption)
  }, [selectedOption])

  const handleCloseForm = () => {
    handleClose()
    setButtonBlock(false)
    formik.resetForm()
    setSelectedOption('')
    setAdvanceFilterSignD({ ...advanceFilterSignD, month: '' })
    setAdvanceFilterDI({ ...advanceFilterDI, month: '' })
  }
  const handleChangeCompanyReceived = e => {
    const options = e.target.options
    const selectedValues = []
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        selectedValues.push(options[i].value)
      }
    }
    formik.setFieldValue('company_code_recipients', selectedValues)
  }

  const [buttonBlock, setButtonBlock] = useState(false)

  return (
    <Dialog
      open={open}
      onClose={handleCloseForm}
      scroll={'paper'}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      className="doc-popup"
      fullWidth
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100vw',
            maxWidth: '100vw',
            mx: 0,
            zIndex: 50,
          },
        },
      }}>
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle
          id="scroll-dialog-title"
          className="text-xl font-bold text-[#ffffff] "
          sx={{
            fontWeight: 700,
            backgroundColor: '#2C65AC',
          }}>
          <span className="font-bold">
            Tạo mới văn bản đi liên thông nội bộ
          </span>
        </DialogTitle>
        <DialogContent>
          <div style={{ marginTop: 12 }}>
            <TextField
              name="document_number"
              id="standard-basic"
              label={
                <>
                  <span
                    style={{
                      display: 'inline-block',
                      color: '#ff4d4f',
                      fontSize: '14px',
                      fontFamily: 'SimSun,sans-serif',
                      lineHeight: 1,
                    }}>
                    *
                  </span>
                  <span> Số hiệu</span>
                </>
              }
              variant="standard"
              sx={{ textAlign: 'center', height: '50px', width: '100%' }}
              onChange={formik.handleChange}
              error={
                formik.errors.document_number && formik.touched.document_number
                  ? true
                  : false
              }
            />
          </div>
          <div>
            <FormControl
              variant="standard"
              sx={{ mt: 1, mb: 1, minWidth: '100%' }}>
              <InputLabel>
                <span
                  style={{
                    display: 'inline-block',
                    color: '#ff4d4f',
                    fontSize: '14px',
                    fontFamily: 'SimSun,sans-serif',
                    lineHeight: 1,
                  }}>
                  *
                </span>
                <span> Loại văn bản</span>
              </InputLabel>
              <Select
                name="document_type"
                sx={{ width: '100%' }}
                defaultValue={'021'}
                onChange={formik.handleChange}
                label="Loại văn bản">
                <MenuItem value={'021'}>Công văn</MenuItem>
                <MenuItem value={'022'}>Quyết định</MenuItem>
                <MenuItem value={'024'}>Tờ trình</MenuItem>
                <MenuItem value={'020'}>Báo cáo</MenuItem>
                <MenuItem value={'025'}>Khác</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div style={{ marginTop: '8px' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <DatePicker
                name="sign_date"
                label={
                  <>
                    <span> Ngày ký</span>
                  </>
                }
                openTo="day"
                views={['day', 'month', 'year']}
                value={advanceFilterSignD.month}
                onChange={handleChangeSignDate}
                inputFormat="DD/MM/YYYY"
                renderInput={params => (
                  <TextField
                    sx={{
                      width: '100%',
                      '& .MuiInputBase-input': {
                        fontSize: '14px',
                      },
                    }}
                    {...params}
                    error={false}
                  />
                )}
              />
            </LocalizationProvider>
          </div>
          <div style={{ marginTop: '12px' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <DatePicker
                name="date_issued"
                label={
                  <>
                    <span> Ngày ban hành</span>
                  </>
                }
                openTo="day"
                views={['day', 'month', 'year']}
                value={advanceFilterDI.month}
                onChange={handleChangeDateIssued}
                inputFormat="DD/MM/YYYY"
                renderInput={params => (
                  <TextField
                    sx={{
                      width: '100%',
                      '& .MuiInputBase-input': {
                        fontSize: '14px',
                      },
                    }}
                    {...params}
                    error={false}
                  />
                )}
              />
            </LocalizationProvider>
          </div>
          <div style={{ marginTop: '12px' }}>
            <TextField
              name="signer"
              id="outlined-multiline-static"
              label=" Người ký"
              // variant="filled"
              sx={{ width: '100%' }}
              value={formik.values?.signer}
              onChange={formik.handleChange}
            />
          </div>
          <div>
            <FormControl
              variant="outlined"
              sx={{ mt: '14px', minWidth: '100%' }}>
              <InputLabel>
                <>
                  <span> Độ khẩn</span>
                </>
              </InputLabel>
              <Select
                name="urgency_level"
                sx={{ width: '100%' }}
                onChange={handleSelectChange}
                label="Độ khẩn"
                value={selectedOption}>
                <MenuItem value={''}>Bỏ chọn độ khẩn</MenuItem>
                <MenuItem value={'001'}>Khẩn</MenuItem>
                <MenuItem value={'002'}>Hỏa tốc</MenuItem>
                <MenuItem value={'003'}>Hỏa tốc hẹn giờ</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div style={{ marginTop: '14px' }}>
            <TextField
              name="title"
              id="outlined-multiline-static"
              label={
                <>
                  <span
                    style={{
                      display: 'inline-block',
                      color: '#ff4d4f',
                      fontSize: '14px',
                      fontFamily: 'SimSun,sans-serif',
                      lineHeight: 1,
                    }}>
                    *
                  </span>
                  <span> Trích yếu</span>
                </>
              }
              multiline
              rows={3}
              // variant="filled"
              sx={{ width: '100%' }}
              value={formik.values?.title}
              onChange={formik.handleChange}
              error={formik.errors.title && formik.touched.title ? true : false}
            />
          </div>
          <div>
            <label
              style={{
                display: 'inline-block',
                color: '#ff4d4f',
                fontSize: '14px',
                fontFamily: 'SimSun,sans-serif',
                lineHeight: 1,
              }}>
              *
            </label>
            <label style={{ margin: '5px' }}>Tài liệu đính kèm:</label>
            <br />
          </div>

          {selectedInternalDocumentOutgoing?.attachments ? (
            selectedInternalDocumentOutgoing?.attachments.map(file => (
              <FileItem
                file={file}
                key={file.id}
                file_id={file.id}
                file_name={file.name}
                file_type={getExtensionFile(file.name)}
              />
            ))
          ) : (
            <EmptyText>Không có.</EmptyText>
          )}

          <div>
            <label
              style={{
                display: 'inline-block',
                color: '#ff4d4f',
                fontSize: '14px',
                fontFamily: 'SimSun,sans-serif',
                lineHeight: 1,
              }}>
              *
            </label>
            <label style={{ margin: '5px' }}>Chọn công ty nhận:</label>
            <br />
            <div style={{ display: 'flex' }}>
              <div
                style={{
                  height: '40px',
                  width: '100%',
                }}>
                <select
                  name="companyReceives"
                  style={{
                    height: '100%',
                    width: '100%',
                    WebkitAppearance: 'none',
                    padding: '5px',
                    outline: 'none',
                    borderRadius: '5px',
                    border: '1.5px solid #d9d9d9',
                  }}
                  placeholder={'-- Nhận ngoài cơ quan --'}
                  onChange={handleChangeCompanyReceived}
                  required
                  multiple>
                  {currentUser?.company?.code &&
                    companyList &&
                    companyList
                      .filter(
                        company => company.code !== currentUser.company.code
                      )
                      .map(company => (
                        <option key={company.code} value={company.code}>
                          {company.name}
                        </option>
                      ))}
                </select>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions
          sx={{ backgroundColor: '#e3e4e9', position: 'sticky', bottom: 0 }}>
          <Button
            sx={{ fontWeight: 600 }}
            onClick={handleCloseForm}
            className="w-[94px] h-[40px] text-sm font-semibold leading-5 text-primary">
            Đóng
          </Button>
          {buttonBlock ? (
            <button
              disabled={true}
              sx={{ fontWeight: 600 }}
              className="opacity-[0.3] uppercase w-[94px] h-[40px] rounded-[100px] text-sm font-semibold leading-5 text-white bg-[#0073C7]">
              {' '}
              Tạo mới
            </button>
          ) : (
            <button
              type="submit"
              sx={{ fontWeight: 600 }}
              className="uppercase w-[94px] h-[40px] rounded-[100px] text-sm font-semibold leading-5 text-white bg-[#0073C7]">
              {' '}
              Tạo mới
            </button>
          )}
        </DialogActions>
      </form>
      {isVisibleAuthoritiesActionModal && (
        <AuthoritiesActionModal
          disabledAuthoritiesTypePicker
          tabActive={DOCUMENT_TYPE.OUTGOING}
          payloadModal={{
            status: true,
            isCreate: true,
            updatePayLoad: null,
          }}
          handleCloseModal={handleToggleAuthoritiesActionModal(false)}
        />
      )}
    </Dialog>
  )
}

export default memo(
  inject(
    'authorityStore',
    'bookStore',
    'loadingAnimationStore',
    'commonStore',
    'fileStore',
    'companyStore',
    'authenticationStore',
    'signedDocumentStore',
    'internalConnectedDocumentStore',
    'internalDocumentStore'
  )(observer(InternalConnectedDocumentOutgoingCreate))
)
